import mountVueOnPage from '../mount_vue'

// True server-side pagination: each page of results is its own request, and
// the bottom sentinel fetches the next page. (This used to download the whole
// store in one ~4s response and merely reveal slices of it.)
mountVueOnPage('items', 'index', {
    data() {
        return {
            items: [],
            count: 0,
            search: '',
            filter: 'recent',
            category: '',
            unseen_items: false,
            searchTimer: null,
            page: 1,
            hasMore: false,
            loadingMore: false,
            observer: null,
            loadTimer: null,
            ready: false, // false until the first fetch resolves — drives the content spinner
        }
    },
    computed: {
        visibleItems() {
            return this.items
        },
    },
    async created() {
        await this.update();
        this.ready = true;
    },
    mounted() {
        // Fetch the next page when the sentinel enters view; debounced so a
        // burst of callbacks collapses into a single request.
        this.observer = new IntersectionObserver(
            (entries) => {
                if (!entries[0].isIntersecting) return
                clearTimeout(this.loadTimer)
                this.loadTimer = setTimeout(() => this.fetchMore(), 200)
            },
            { rootMargin: '120px' },
        )
        if (this.$refs.sentinel) this.observer.observe(this.$refs.sentinel)
    },
    unmounted() {
        if (this.observer) this.observer.disconnect()
    },
    methods: {
        params(page) {
            return { search: this.search, filter: this.filter, category: this.category, page }
        },
        // Fresh result set: back to page one.
        async update() {
            this.page = 1
            const posts = await axios.get('/items.json', { params: this.params(1) })
            if (posts.data) {
                this.items = posts.data.items;
                this.count = posts.data.count;
                this.hasMore = posts.data.has_more;
                this.unseen_items = posts.data.unseen_items;
            }
        },
        async fetchMore() {
            if (!this.hasMore || this.loadingMore) return
            this.loadingMore = true
            try {
                const next = this.page + 1
                const posts = await axios.get('/items.json', { params: this.params(next) })
                if (posts.data) {
                    this.page = next
                    this.items = this.items.concat(posts.data.items)
                    this.hasMore = posts.data.has_more
                }
            } finally {
                this.loadingMore = false
            }
        },
        // Debounce typing so we don't fire a request per keystroke.
        debouncedUpdate() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => this.update(), 250);
        },
    },
    watch: {
        async search() {
            this.debouncedUpdate();
        },
        async filter() {
            await this.update();
        },
        async category() {
            await this.update();
        }
    }
})
